import tooltipMessage from 'core/controllerPlans/tooltipMessage'
import setAttribute from 'utils/DOM/setAttribute'
import textContent from 'utils/DOM/textContent'
import toggleClass from 'utils/DOM/toggleClass'
import getBenefitsTooltips from 'utils/pivot/plan/getBenefitsTooltips'
import tooltip from 'core/DOM/tooltip'

function setTooltips(state) {
  const { plan, isBTM, totalProducts } = state

  const tooltips = getBenefitsTooltips()

  setAttribute('.tooltip-deductible', 'title', tooltips.deductible)
  setAttribute('.tooltip-coinsurance', 'title', tooltips.coinsurance)
  setAttribute('.tooltip-coverage', 'title', tooltips.coverage)
  setAttribute('.tooltip-moop', 'title', tooltips.moop)
  setAttribute('.tooltip-duration', 'title', tooltips.period)

  tooltip.init()

  // cost description tooltip
  const tooltipContent = tooltipMessage(
    state,
    plan,
    plan.multiCarrierPlan ? plan.durations[0]?.monthly : undefined
  )

  textContent(
    '.js-products-count',
    `${totalProducts} product${totalProducts > 1 ? 's' : ''} included`
  )

  if (tooltipContent) {
    const tooltipCost = $('.tooltip-cost-total')

    toggleClass('.tooltip-cost-total', 'd-none', totalProducts > 1)
    tooltip.initCustomTooltip({
      $holder: tooltipCost,
      customClass: 'hc-tooltip',
      content: tooltipContent
    })
  } else {
    toggleClass('.js-tooltip-cost', 'd-none', true)
  }
}

export default setTooltips
